import api from './index';

export default {
  getAll() {
    return api.get('/services');
  },
  create(data) {
    return api.post('/services', data);
  },
  update(id, data) {
    return api.put(`/services/${id}`, data);
  },
  delete(id) {
    return api.delete(`/services/${id}`);
  },
  assignToCustomer(customerId, data) {
    return api.post(`/customers/${customerId}/services`, data);
  },
  updateAssignment(customerId, assignmentId, data) {
    return api.put(`/customers/${customerId}/services/${assignmentId}`, data);
  },
  removeAssignment(customerId, assignmentId) {
    return api.delete(`/customers/${customerId}/services/${assignmentId}`);
  },
  markComplete(customerId, assignmentId, data = {}) {
    return api.post(`/customers/${customerId}/services/${assignmentId}/complete`, data);
  },
};
